import React from 'react';
import { Home, MapPin, Ruler, Bed, Bath, Car, Layers } from 'lucide-react';

const PropertiesDetails = ({ listing }) => {
  const details = listing.specialized_data || {};
  
  if (!details || details._type !== 'properties') return null;

  const specs = [
    { icon: Home, label: 'Property Type', value: details.property_type },
    { icon: Ruler, label: 'Plot Size', value: details.plot_size },
    { icon: Bed, label: 'Bedrooms', value: details.bedrooms },
    { icon: Bath, label: 'Bathrooms', value: details.bathrooms },
    { icon: Car, label: 'Parking Spaces', value: details.parking_spaces },
    { icon: Layers, label: 'Floors', value: details.floors },
  ];

  const amenities = [
    { label: 'Furnished', value: details.is_furnished },
    { label: 'Water Supply', value: details.water_supply },
    { label: 'Electricity', value: details.electricity },
    { label: 'Security', value: details.security },
    { label: 'Internet', value: details.internet },
    { label: 'Garden', value: details.garden },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Property Details</h2>
      
      {/* Basic Specs */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        {specs.map((spec, index) => {
          if (!spec.value) return null;
          return (
            <div key={index} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
              <div className="p-2 bg-white rounded-lg shadow-sm">
                <spec.icon className="w-5 h-5 text-green-600" />
              </div>
              <div className="flex-1">
                <p className="text-sm text-gray-500">{spec.label}</p>
                <p className="font-medium text-gray-900">{spec.value}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Amenities */}
      {amenities.filter(a => a.value).length > 0 && (
        <div className="mb-6">
          <h3 className="font-medium text-gray-900 mb-3">Amenities</h3>
          <div className="flex flex-wrap gap-2">
            {amenities.map((amenity, index) => {
              if (!amenity.value) return null;
              return (
                <span 
                  key={index} 
                  className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-green-100 text-green-800"
                >
                  {amenity.label}
                </span>
              );
            })}
          </div>
        </div>
      )}

      {/* Additional Details */}
      {(details.year_built || details.property_condition || details.rental_terms) && (
        <div className="border-t pt-4">
          <h3 className="font-medium text-gray-900 mb-3">Additional Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {details.year_built && (
              <div>
                <p className="text-sm text-gray-500">Year Built</p>
                <p className="font-medium text-gray-900">{details.year_built}</p>
              </div>
            )}
            {details.property_condition && (
              <div>
                <p className="text-sm text-gray-500">Condition</p>
                <p className="font-medium text-gray-900 capitalize">{details.property_condition}</p>
              </div>
            )}
            {details.rental_terms && (
              <div>
                <p className="text-sm text-gray-500">Rental Terms</p>
                <p className="font-medium text-gray-900">{details.rental_terms}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertiesDetails;